<tnb-erzeugungsanlage-detail-summenerzeuger
    [anlagentypen]="anlagentypen"
    [createNewMode]="createNewMode"
    [readonly]="readonly$ | async"
    [erzeugungsanlage]="erzeugungsanlage$ | async">
</tnb-erzeugungsanlage-detail-summenerzeuger>
